// {{ $t('立即添加') }}
// $t('立即添加')
// this.$t('立即添加')

export default {
  企业云展评分描述: 'The higher the score, the higher the exposure weighting, so hurry up and perfect it!',
  您的企业云展得分: 'Your Enterprise Cloud Show Score',
  信息编辑: 'Information Editor',
  编辑预览我的企业云展: 'Edit / Preview My Enterprise Cloud Show',
  企业已禁用: 'Companies have disabled',
  加入该企业: 'Join the company',
  是否: 'whether',
  当前企业已被认证: 'Current companies are certified',
  加入方式: 'Join Method',
  受邀申请: 'Invited',
  主动申请: 'Proactive',
  企业基本信息: 'Company Basic Information',
  职务: 'Position',
  '（必填）': '(Required)',
  '（选填）': '(Optional)',
  语言版本: 'Supported languages',
  当前支持的语言版本: 'Language versions currently supported',
  简体中文: 'Simplified Chinese',
  英文: 'English',
  中英文: 'Chinese and English',
  云展动力平台支持多语言版本显示提示语:
    'The Yunzhan power platform supports multi-language display. The improvement of the multi-language version helps companies acquire potential customers from different countries, and helps customers from different countries understand your company more easily.',
  英文未完成:
    'The system detects that you have filled in some fields in the [English] version, but have not completed the remaining required fields. Do you want to continue submitting? If you continue to submit, the [English] version will not be saved, please be aware!',
  中文未完成:
    'The system detects that you have filled in some fields of the [Chinese] version, but have not completed the remaining required fields. Do you want to continue to submit? If you continue to submit, the [Chinese] version will not be saved, please be aware!',
  申请角色提示1:
    'After the enterprise role application is submitted successfully, the platform will review it within 1-3 working days, and the review result will be notified by an internal message, please pay attention;',
  申请角色提示2:
    'Corporate information related content is prohibited from publishing illegal and bad information involving politics, pornography, violence, vulgarity, etc. Once discovered, the platform will have the right to freeze your account and retain legal responsibility;',
  申请角色提示3:
    'Companies can choose to supplement translation content in other languages according to their needs in different markets and support simplified Chinese (default) and English;',
  申请角色提示4:
    'The current Yunzhan power platform supports simplified Chinese and English languages. In order to obtain interest and intention orders from customers from different countries, it is strongly recommended that companies improve the language version content supported by the current system;',
  申请角色提示5:
    'At least one language must be completed before the submission can be successfully submitted, not all of them can be empty;',
  新浪微博: 'Sina Weibo',
  填写企业资料: 'Enter Company Info',
  企业名称: 'Company Name',
  城市: 'city',
  企业简介: 'Introduction',
  企业宣传册: 'Company Brochure',
  产品服务: 'Products & Services',
  企业展览: 'Exhibitions',
  企业LOGO: 'Company Logo',
  公司简介: 'Company Introduction.',
  公司联系方式: 'Company Contact Info.',
  删除当前图片: 'Delete Current Images',
  业务联系信息: 'Business Contact Info',
  点击上传LOGO: 'Upload logo',
  '公司认证(二选一)': 'Company Certification',
  企业LOGO图片格式说明:
    'JPG/PNG formats are accepted. Maximum file size: 5M. Preferably white or transparent background. Minimum image resolution: 300x300px.',
  营业执照图片格式说明: 'JPG/PNG formats are accepted. Maximum file size: 10M.',
  营业执照: 'Business License',
  营业执照原件: 'Original Business License',
  '请输入工商局注册的完整企业名称,120个字符以内':
    'Please enter the complete company name registered by the Industrial and Commercial Bureau. (Character Limit: 240)',
  请输入企业官网: 'Please enter official website address.',
  请输入联系人: 'Please enter name of contact person.',
  请输入联系手机号码: 'Please enter the cellphone number.',
  请输入联系邮箱: 'Please enter E-mail address.',
  请输入岗位: 'Please enter your position.',
  请选择3D类型: 'Please select the type of 3D display.',
  请输入3D标题: 'Please enter a title.',
  请输入3D链接: 'Please enter the link.',
  请填写3D超链接: 'Please enter the hyperlink.',
  请上传3D封面图: 'Please upload a cover image.',
  请上传企业Logo: 'Please upload your company logo.',
  请上传营业执照: 'Please upload the business license.',
  请输入正确的手机号码: 'Please enter the correct cellphone number！',
  请输入正确的邮箱地址: 'Please enter the correct E-mail address！',
  请输入正确的固定电话号码: 'Please enter the correct fixed phone number！',
  '请输入联系方式,手机号/固定电话至少填一个！': 'Please enter at least one  cellphone/fixed phone number.',
  请输入个人作品官网: 'Please enter the link to your personal works.',
  '请输入工商局注册的完整公司名称,120个字符以内':
    'Please enter the complete company name registered by the Industrial and Commercial Bureau. (Character Limit: 240)',
  '请输入详细地址,120个字符以内': 'Please Enter the detailed address. (Character Limit: 240) ',
  '请输入公司的法人姓名,10个字符以内':
    'Please enter the name of the company’s legal representative. (Character Limit: 20)',
  请输入公司联系邮箱: 'Please enter your company’s E-mail address.',
  请输入统一社会信用代码: 'Please enter the Unified Social Credit Code.',
  请输入正确的统一社会信用代码: 'Please enter the correct Unified Social Credit Code！',
  请上传公司Logo: 'Please upload your company logo.',
  请填写企业注册资本: 'Please enter the Registered Capital',
  请上传公司营业执照: 'Please upload your company’s business license.',
  '请上传身份证,正面图片': 'Please upload your ID card’s front-side copy.',
  '请上传身份证,反面图片': 'Please upload your ID card’s backside copy.',
  请上传公函文件: 'Please upload official documents.',
  请输入邮箱: 'Please enter E-mail address.',
  请输入正确的邮箱: 'please enter the correct E-mail address！',
  请输入身份证号码: 'Please enter your ID number.',
  请输入正确的网址: 'please enter the correct website address.',
  请输入正确的身份证号码: 'please enter the correct ID number.！',
  请输入微信号: 'Please enter the WeChat account.',
  请输入真实姓名: 'Please enter your real name.',
  请输入详细地址: 'Please enter a detailed address of no more than 120 characters.',
  公司法人姓名: 'company’s legal representative.',
  请输入公司法人姓名: 'Please enter the name of the company’s legal representative.',
  请输入公司简介: 'Please enter a short company introduction.',
  请输入自我介绍: 'Please enter your self-introduction.',
  请输入正确的链接地址: 'Please enter the correct link.',
  请输入子账号: 'Please enter an employee account.',
  请输入查看者用户名: 'Please enter a username.',
  请输入转发者用户名: 'Please enter a username.',
  请输入点赞者用户名: 'Please enter a username.',
  请输入主动分享者用户名: 'Please enter a username.',
  主动分享者: 'User',

  请输入企业动态内容: 'Please enter content. (Character Limit: 4000, punctuation marks included).',
  '2000个字符以内': 'Character Limit: 4000',
  请输入企业注册时间: 'Please enter the date of registration.',
  请选择企业员工人数: 'Please select the number of employees.',
  请输入11位纯数字手机号: 'Please enter an 11-digit phone number.',
  '请输入联系邮箱,60个字符以内': 'Please enter an E-mail address. (Character Limit: 120)',
  '请填写合作企业名称,最多120个字符': 'Please Enter the name of partner company. (Character Limit: 240)',
  '请填写链接,最多120个字符': 'Please enter a link. (Character Limit: 240) ',
  '请填写联系人姓名,最多30个字符': 'Please enter contact name. (Character Limit: 60)',
  '请填写认缴金额,最多12个字符': 'Please enter the amount of subscribed capital. (Character Limit: 24)',
  '请填写纯数字,单位人民币': 'Please enter numbers only. (Unit: RMB)',
  请填写投资比例: 'Please enter the investment proportion.',
  '请填写纯数字,最大100.00%,单位%': 'Please enter numbers only. (0.00%~100.00%)',
  '请填写投资机构的企业名称,最多120个字符': 'Please enter the name of investor company. (Character Limit: 240)',
  '请填写对外投资的企业名称,最多120个字符': 'Please enter the name of investee company. (Character Limit: 240)',
  请填写上市的国家: 'Please enter the country where your company got listed.',
  请填写上市的交易机构: 'Please enter the name of stock exchange where your company got listed.',
  请填写主营产品: 'Please enter the main products. ',
  请填写手机号或者固定电话: 'Please enter a cellphone/fixed phone number',
  请填写正确的手机号码: 'Please enter the correct cellphone number',
  请填写固定电话号码: 'Please enter the correct fixed phone number',
  请选择: 'Select',
  请选择企业性质: 'Please select the nature of business.',
  请选择企业所在地区: 'Please select a region.',
  请选择至少一项擅长展览行业: 'Please select at least one industry.',
  请选择至少一项擅长会议行业: 'Please select at least one industry.',
  请选择至少一项擅长设计类型: 'Please select at least one category.',
  请选择至少一项擅长行业分类: 'Please select at least one industry.',
  请选择头条分类: 'Please select a category.',
  请选择头条行业: 'Please select an industry.',
  请选择展厅模型分类: 'Please select a category.',
  请选择展览行业: 'Please select an industry.',
  请选择展览行业分类: 'Please select an industry.',
  请选择会议行业分类: 'Please select an industry.',
  请选择详细地区或输入关键字搜索: 'Please select a region or enter keywords.',
  '请选择国别/国家/省份或地区/市或地区': 'Please select a country/province/city.',
  填写业务联系信息: 'Enter Business Contact Info',
  联系人: 'Contact Name',
  '手机号/固定电话': 'Cellphone/Fixed Phone Number',
  联系邮箱: 'E-mail',
  岗位: 'Position',
  企业官网: 'Company Official Website',
  企业宣传视频: 'Company Promotional Video',
  服务商类型: 'Type of Service Provider',
  真实姓名: 'Real Name',

  身份证号码: 'ID Number',
  个人身份证正反面: 'Your ID Card’s Front-Side & Backside Copy',
  公司法人身份证正反面: 'Front-Side & Backside Copy of the Legal Representative’s ID Card',
  '身份证正面（人头）': 'Front-Side Copy (Portrait)',
  '身份证反面（国徽）': 'Backside Copy(National Emblem)',
  所在地址: 'Address',
  个人作品官网: 'link to Your Personal Works',
  自我介绍: 'Self-Introduction',
  公司名称: 'Company Name',
  公司LOGO: 'Company Logo',
  公司地址: 'Company Address',
  认证申请公函: 'Official Letter of Verification Application',
  样本下载: 'Example File Download',
  公司联系邮箱: 'Company E-mail',
  统一社会信用代码: 'Unified Social Credit Code',
  微信号: 'WeChat',
  感兴趣的展览: 'Exhibitions You Are Interested in',
  感兴趣的会议: 'Conferences You Are Interested in',
  感兴趣的资讯: 'News You Are Interested in',
  擅长展览行业: 'Industry You Are Experienced in',
  擅长会议行业: 'Industry You Are Experienced in',
  选择擅长行业或属性: 'Please select an or industry or category you are experienced in.',
  基本资料: 'Basic Info',
  公司资料: 'Company Info',
  添加企业3D信息: 'Add 3D Display',
  企业3D: '3D Display',
  '3D类型': 'Category',
  '3D标题': 'Title',
  '3D链接': 'URL',
  '3D封面图': 'Cover Image',
  点击上传3D封面图: 'Upload Cover Image',
  请上传: 'Click to Upload',
  立即上传: 'Upload Now',
  已上传文件: 'Uploaded Files',
  正在上传: 'Uploading',
  上传成功: 'Upload Successful',
  更新申请: 'Submit',
  立即申请: 'Apply Now',
  提交成功: ' Submission Successful ',
  返回会员中心: 'Back to User Center',
  '只可以上传jpg/png 格式的图片': 'Only JPG/PNG formats are accepted.',
  '请上传 300*300 尺寸以上图片,当前图片': 'Minimum image size: 300*300. Current image size:',
  '请上传 450*450 尺寸以上图片,当前图片': 'Minimum Image Size: 450*450. Current image size:',
  '请上传 500*500 尺寸以上图片,当前图片': 'Minimum Image Size: 500*500. Current image size:',
  '图片解析失败,请确保图片是正确的': 'Upload unsuccessful! Please check your image and try again.',
  '图片大小不可以超过 2MB!': ' Maximum file size: 2MB.!',
  '图片大小不可以超过 5MB!': 'Maximum file size: 5MB!',
  '图片大小不可以超过 10MB!': 'Maximum file size: 10MB!',
  视频格式说明: 'MP4 format is accepted. Maximum file size: 200M.',
  视频大小不可以超过200MB: 'Maximum file size: 200MB!',
  大小不可以超过200MB: 'Maximum file size: 200MB!',

  只能上传mp4格式文件: 'Only MP4 format is accepted！',
  再次确认资料提交提示:
    'Please make sure your info here is correct before submission. Your info cannot be edited during review. You will be notified of your review result soon. Please wait patiently.',
  身份证照片说明: 'Please reset assured that your personal info is kept safely.',
  '固话号码,由7到8位数字组成': 'Please enter a fixed phone number containing 7-8 numbers.',
  '选择您感兴趣的展览/会议/展厅模型/资讯':
    'Please select the exhibitions/conferences/designs/news you are interested in.',
  '10个字符以内,请如实填写': 'Please Enter truthfully. (Character Limit: 20)',
  '18个字符以内,请如实填写': 'Please Enter truthfully. (Character Limit: 36)',
  最多填写10个汉字: 'Character Limit: 20',
  最多填写16个字符: 'Character Limit: 16',
  最多填写75个汉字: 'Character Limit: 150',
  最多填写500个汉字: 'Character Limit: 1000',
  最多填写600个汉字: 'Character Limit: 1200',
  最多填写800个汉字: 'Character Limit: 1600',
  最多填写2000个汉字: 'Character Limit: 4000',
  最多填写1000个汉字: 'Character Limit: 2000',
  '200个字符以内': 'Character Limit: 400',
  上传带有公司盖章的认证申请公函: 'Upload the Official Letter of Verification Application With Company Chop',
  上传企业的3D展示链接的提示:
    'A 3D display of your products, company offices, manufacturing facilities, and etc. is an effective way to boost your corporate image and credibility.',
  参展商认证申请成功提示1:
    'Your submission will be processed within 2-3 working days. Remember to check your Message Center for your review result.',
  参展商认证申请成功提示2:
    'While your submission is being reviewed, you can prepare for your product listing in advance. Once you are an Exhibitor, you can upload your products on User Center>Manage Products.',
  参展商认证申请成功提示3:
    'Once you are an Exhibitor, you can also edit your company page on User Center>My Company by completing your company info, uploading company photos, videos, and etc.',
  参展商认证编辑成功提示1:
    'Your submission will be processed within 2-3 working days. Remember to check your Message Center for your review result, or look out for changes in your User Center.',
  云展动力服务平台审核提示:
    'Your submission will be processed within 2-3 working days. If necessary, we will call to confirm your info. Please keep your phone reachable.',
  // 企业云展
  '提示：您的企业云展系统已被平台禁用': 'Notice: Your company page has been banned.',
  违规原因如下: 'Reasons of Violation：',
  云展动力服务平台审核中提示:
    'Your submission will be processed within 2-3 working days. Remember to check your Message Center for your review result.',
  企业云展系统完善度: 'Company Profile Completeness ',
  您的企业云展系统得分: 'Your company page scores',
  完善度分数: 'points',
  超过了: 'You have surpassed ',
  用户: 'of users.',
  企业被查看累计数: 'Total Views',
  企业被转发累计数: 'Total Reposts',
  主动分享累计数: 'Total Shares',
  企业被点赞认同累计数: 'Total Likes',
  企业子账号效果汇总: 'Employee Accounts Data Summary',
  '员工转发/裂变的效果明细': 'Details Data Analysis',
  完善企业云展系统提示:
    'The more complete your company profile, the better the odds that potential buyers will find you in the first place. So, improve your company profile now!',
  预览: 'Preview',
  分享: 'Share',
  企业信息: 'Company Basic Info',
  '企业名称/logo/营业执照/简介/官网/地址/视频简介':
    'Company Name/Logo/Business License/Introduction/Official Website/Address/Corporate Video',
  完成度: 'Completeness ',
  继续完善: 'Edit',
  企业基础信息: 'Company Base Info',
  企业工商信息: 'Company Registration Info',
  企业工商: 'Company Registration Info',
  '企业注册时间/注册资本/主营产品/员工数/企业性质/上市企业/世界500强企业/对外投资/投资机构':
    'Date of Registration/Registered Capital/Main Products/Number of Employees/Nature of Business/Listed Company/Fortune Global 500 Company/Investor/Investment',
  企业内容展示: 'Company Page',
  企业内容: 'Company Page',
  '企业相册/企业荣誉/企业3D/合作伙伴': 'Photos/Achievements/3D Display/Partners',
  企业联系信息: 'Contact Info',
  企业联系: 'Contact Info',
  '联系人/联系方式/社交媒体/微信公众号二维码/微信小程序二维码':
    'Contact Person/Contact Info/Social Media/WeChat Official Account/WeChat Applet',
  // count企业云展统计
  动作类型: 'Content Viewed',
  动作内容: 'Action',
  查看来源: 'Viewed on',
  查看时间: 'Date',
  浏览时长: 'Time on Page',
  查看次数: 'Total Views',
  转发来源: 'Reposted on',
  转发时间: 'Date',
  转发次数: 'Total Reposts',
  点赞来源: 'Liked on',
  点赞时间: 'Date',
  点赞次数: 'Total Likes',
  查看者详情: 'User Info',
  转发者详情: 'User Info',
  点赞者详情: 'User Info',
  分享者详情: 'User Info',
  主动来源: 'Actively share on',
  企业点赞累计数: 'The Company’s Total Likes by Visitors',
  企业主动分享累计数: 'Total Shares by the Company',
  查看者用户名: 'Username',
  转发者用户名: 'Username',
  点赞者用户名: 'Username',
  主动分享者用户名: 'Username',
  今日: 'Today',
  昨日: 'Yesterday',
  近7日: 'Last 7 Days',
  近30日: 'Last 30 Days',
  主动分享数注解:
    'Our Total Shares refers to the number of times contents on your company page shared by your employee accounts;',
  被转发数注解:
    'Total Reposts by Visitors refers to the number of times contents on your company page reposted by others via the links shared by your employee accounts;',
  被查看数注解:
    'Total Views by Visitors refers to the number of times contents on your company page viewed by others via the links shared by your employee accounts or other users.',
  用户头像: 'Profile Picture',
  '子账号（或主账号)': 'Employee Account(Or Company Account）',
  主动分享数: 'Our Total Shares',
  被转发数: 'Total Reposts by Visitors',
  被查看数: 'Total Views by Visitors',
  被查看用户数: 'Total Visitors',
  已联系用户数: 'No. of Users Contacted',
  人均浏览时长: 'Average View Duration',
  联系率: 'Contact Rate',
  查看率: 'Click Rate',
  截止昨日: 'Until Yesterday',
  截止今日: 'Until Today',
  被查看记录: 'Views by Visitors',
  被转发记录: 'Reposts by Visitors',
  被点赞记录: 'Likes by Visitors',
  主动分享记录: 'Our Sharing History',
  未知身份游客: 'Unregistered Visitors',
  洽谈: 'Chat',
  游客: 'visitor',
  我撤回了一条消息: 'I recalled a message',
  对方撤回了一条消息: 'The other party recalled a message',
  撤回: 'recall',
  已读: 'read',
  查看全部: 'view all',
  查看者: 'User',
  最新查看时间: 'Last View',
  最新查看来源: 'Viewing Device',
  累计: 'Total',
  累计查看次数: 'Total Views',
  联系状态: 'Contact Status',
  已联系: 'Contacted',
  未联系: 'Not Yet Contacted',
  转发者: 'User',
  最新来源: 'Latest source',
  最新转发来源: 'Reposted on',
  最新转发时间: 'Last Repost',
  累计转发次数: 'Total Reposts',
  点赞者: 'User',
  最新点赞来源: 'Liked on',
  最新点赞时间: 'Last Like',
  累计点赞次数: 'Total Likes',
  主动分享来源: 'Shared on',
  主动分享次数: 'Total Shares',
  主动分享时间: 'Last Share',
  发布企业动态: 'Publish Company News',
  企业动态总浏览量: 'Total Views',
  企业动态总点赞量: 'Total Likes',
  动态内容: 'Content',
  动态图片: 'Picture',
  '动态图片(选填)': 'Picture(Optional)',
  动态图片上传格式提示1: 'JPG/PNG formats are accepted. Maximum file size: 10M. Minimum image resolution: 300x300px.',
  动态图片上传格式提示2: '9 Pictures at Most',
  动态内容不能为空: 'Content cannot be empty！',
  添加动态成功: 'News Added Successfully',
  删除动态成功: 'News Deleted Successfully',
  上一步: 'Last',
  下一步: 'Next',
  确定提交: 'Submit',
  企业云展系统编辑提交提示:
    'Your submission will be processed within 2-3 working days. Remember to check your Message Center for your review result.',
  // 企业名称: 'Company Name',
  企业logo: 'Company Logo',
  预览图片: 'Preview',
  企业营业执照: 'Company Business License',
  营业执照上传要求提示1: 'JPG/PNG formats are accepted. Maximum file size: 10M',
  营业执照上传要求提示2:
    'A good business license photo can add to your business’s credibility. Please make sure the business licence shown on the photo is complete, clear, and legible.',
  营业执照上传要求提示3:
    'For overseas companies, please upload the photo of a valid document issued by the local government which can be used to prove the legitimacy of your business.',
  '公司认证（二选一）': 'Please select a verification method.',
  法人身份证正反面: 'front-side & Backside Copy of the Legal Representative’s ID Card',
  '二选一,企业法人身份证正反面或认证申请公函':
    'Please upload the front-side & backside copy of the legal representative’s ID card or the Official Letter of Verification Application.',
  身份证正反面: 'ID card’s Front-Side and Backside Copy.',
  企业简介提示:
    'Please provide an overall description of your company. You can introduce it from aspects like company history, achievements, and etc.',
  企业地址: 'Company Address',
  预览视频: 'Preview',
  删除当前视频: 'Delete This Video',
  企业注册时间: 'Date of Registration',
  企业注册资本: 'Registered Capital',
  主营产品: 'Main Products',
  企业员工数: 'Number of Employees',
  '请如实填写注册资本,单位：人民币（¥）': 'Please enter the amount of registered capital truthfully. (Unit: Yuan)',
  企业性质: 'Nature of Business',
  上市企业: 'Listed Company',
  '若是上市企业,请完善上市的国家、上市交易机构名称+代码':
    'For listed company, please enter the country, name and code of the stock exchange where the company got listed.',
  '例如美国-纳斯达克 AMZN,中国-深交所 SZJY': 'Examples: United States-NASDAQ AMZN, China-Shenzhen Stock Exchange SZJY.',
  世界500强企业: 'Fortune Global 500 Company',
  是: 'Yes',
  否: 'No',
  所有: 'All',
  世界500强企业说明: 'If your company is in the Fortune Global 500 list, please select “Yes”,. Otherwise, select “No”.',
  对外投资: 'Investee',
  投资比例: 'Investment Proportion',
  认缴金额: 'Subscribed Capital',
  暂无对外投资数据: 'No content yet.',
  添加对外投资: 'Add Investee',
  对外投资说明: 'Please list the entities your company has invested in.',
  投资机构: 'Investor',
  暂无投资机构数据: 'No content yet.',
  列出自己企业的股东机构: 'Please list the shareholders of your companies.',
  投资机构的企业: 'Investor Company',
  对外投资的企业: 'Investor Company',
  投资机构的企业LOGO: 'Investor Company Logo',
  对外投资的企业LOGO: 'Investor Company Logo',
  // 投资比例: 'Investment Proportion',
  // 认缴金额: 'Subscribed Capital',
  万元: 'Million US Dollars',
  仅支持纯数字输入: 'Numbers Only',
  对外投资企业名不能为空: 'Company name cannot be empty.',
  '信息有误或未填写,请检查': 'One or more fields have an error. Please check and try again.',
  // 联系人: 'Contact Name',
  先生: 'Mr',
  女士: 'Ms',
  联系方式: 'Contact Info',
  社交媒体: 'Social Media',
  微信公众号二维码: 'QR Code of WeChat Official Account',
  最多填写120个字符: 'Characters Limit: 240',
  企业相册: 'Company Photos',
  企业相册上传提示1: 'You can upload 30 photos at most. JPG/JPGN/PNG formats are accepted. Maximum file size: 10M',
  企业相册上传提示2:
    'It is recommended to upload photos of your company offices, warehouses, showrooms, workshops, team building activities, and etc.',
  企业荣誉: 'Achievements',
  企业荣誉上传提示1: 'You can upload 15 photos at most. JPG/JPGN/PNG formats are accepted. Maximum file size: 10M.',
  点击添加: 'Add',
  企业3D上传提示1:
    'A 3D display of your products, company offices, manufacturing facilities, and etc. is an effective way to boost your corporate image and credibility.',
  企业3D上传提示2: 'Each company can upload one 3D panorama (360 degree aerial panoramic photo).',
  合作伙伴: 'Partners(Optional)',
  合作伙伴上传提示1:
    'By listing your company’s major clients and business partners, you can effectively demonstrate your company’s influence and competitiveness.',
  合作伙伴上传提示2: 'You can add 20 companies at most.',
  添加合作伙伴: 'Add Partner',
  合作企业名称: 'Company Name',
  合作企业logo: 'Company Logo',
  合作企业名不能为空: 'Company name cannot be empty.',
  // 客户数据
  今日新增: 'Today',
  同比: 'Increased',
  昨日新增: 'Yesterday',
  累计新增: 'Cumulative Additions',
  详细数据分析: 'Detailed Data Analysis',
  名片新增被查看: 'Latest Views',
  名片新增被转发: 'Latest Reposts',
  名片新增被点赞: 'Latest Likes',
  新增主动分享数: 'Latest Shares',
  我的分享: 'My Sharing',
  我的分享记录: 'My Sharing History',
  我的分享来源: 'Shared on',
  我的分享次数: 'Total Shares',
  我的分享时间: 'Date',
  查看详细数据分析: 'Detailed Data Analysis',
  被转发详细数据分析: 'Detailed Data Analysis',
  被点赞详细数据分析: 'Detailed Data Analysis',
  主动分享详细数据分析: 'Detailed Data Analysis',
  所属的子账号: 'Affiliated Employee Accounts',
  详情: 'Details',
  次数: 'Times',
  平均时长: 'Average View Duration',
  次: 'Total View',
  '次(多次)': 'Total Views',
  '分钟/次': 'Minutes Per View',
  '次数/平均时长': 'Total Views/Average Duration',
  企业3D全景: 'Company 3D Panorama',
  资讯: 'News',
  时: 'Hour',
  小时: 'Hour',
  分: 'Minute',
  秒: 'Second',
  // 中文环境不使用
  今日数据汇总: 'Today’s Data Summary',
  昨日数据汇总: 'Yesterday’s Data Summary',
  近7日数据汇总: 'Last 7 Days’ Data Summary',
  近30日数据汇总: 'Last 30 Days’ Data Summary',
  近90日数据汇总: 'Last 90 Days’ Data Summary',
  截止昨日数据汇总: 'Data Summary Till Yesterday',
  // 子账号
  添加子账号的说明:
    'To add an existing user to your employee accounts, please first make sure it isn’t a company account.',
  子账号索取验证码说明: 'Please contact the owner of the account you entered above for the verification code.',
  一键生成子账号: 'Create New Employee Account',
  手动生成子账号: 'Add Manually',
  企业子账号: 'My Employee Accounts',
  子账号状态: 'Status',
  状态: 'Status',
  正常: 'Normal',
  锁定: 'Locked',
  禁用: 'Suspended',
  账号: 'Account',
  请输入完整子账号搜索: 'Please enter a complete employee account.',
  客户列表: 'Customers',
  企业已获取的客户: 'Customers',
  企业已获取的客户提示:
    'In the same enterprise, when multiple employees share with the same customer, the customer can only be bound by one employee sub account!',
  绑定状态: 'Status',
  未绑定: 'Free',
  已绑定: 'Linked',
  请输入公司名称: 'Please enter company name.',
  子账号创建成功: 'New Employee Account Created Successfully',
  添加子账号: 'Add Employee Account',
  请输入云展动力账号: 'Please enter an account.',
  '请输入已注册的手机号/邮箱': 'Please enter a registered phone number/e-mail address.',
  发送验证码: 'Send Verification Code',
  验证码: 'Verification Code',
  新密码不能为空: 'New password cannot be empty.',
  用户名: 'Username',
  首次绑定时间: 'First Linked on',
  所属人: 'Current Contact Person',
  子账号类型: 'Type of Employee Account',
  创建时间: 'Created on',
  生成时间: 'Created on',
  绑定客户数: 'No. of Customers',
  '请填写账号,再发送验证码': 'Please enter an account to send verification code.',
  云展动力账号不能为空: 'Account cannot be empty.',
  验证码不能为空: 'Verification code cannot be empty.',

  完善分: 'perfect score',
  我的名片: 'Personal cloud exhibition system',
  企业云展系统: 'Enterprise cloud exhibition system',
  累计客户查看: 'Cumulative Customer Views',
  累计客户转发: 'Cumulative customer forwarding',
  累计客户点赞: 'Accumulated customer likes',
  昨天新增: 'Added yesterday',
  去邀请: 'to invite',
  去邀约: 'to invite',
  去查看: 'to view',
  查看企业云展: 'View Enterprise Cloud Show',
  企业客户数据概况: 'Enterprise customer data overview',
  我的客户数据概况: 'My Customer Data Profile',
  快捷服务: 'Express service',
  邀请员工: 'Invite employees',
  同事通过点击链接可以加入企业: 'Colleagues can join the company by clicking the link',
  新增客户查看: 'Add customer view',
  新增客户转发: 'Add customer forwarding',
  新增客户点赞: 'Add customer likes',
  未跟进客户: 'Not following up',
  已跟进客户: 'has been followed up',
  员工管理: 'Staff management',
  跟进状态: 'follow up status',
  已跟进: 'followed up',
  未跟进: 'not followed up',

  // 2021/4/22 企业云展改版
  客户: 'Customers',
  IP地址: 'IP Address',
  客户数据Top10: 'Customer Data Top 10',
  客户查看: 'Total Views by Customers',
  客户转发: 'Total Shares by Customers',
  客户点赞: 'Total Likes by Customers',
  主动分享: 'Total Shares by Employees',
  我的分享营销: 'Total Shares by Employees',
  '员工(或管理者)': 'Employee (Or Administrator)',
  客户数: 'Number of customers',
  明细: 'detail',
  今天: 'Today',
  昨天: 'Yesterday',
  近7天: 'Last 7 Days',
  近30天: 'Last 30 Days',
  近90天: 'Last 90 Days',
  数据汇总: 'Data Summary',
  所有数据明细: 'Detail Data',
  员工分享: 'Shares by Employees',
  员工获客数: 'Views by Employees’ Customers',
  员工获客数TOP10: 'Views by Employees’ Customers Top 10',
  '暂无数据，不如主动出击，立即去分享~': 'No data, it is better to take the initiative and share it immediately~',
  员工的客户查看数: 'Views by Employees’ Customers',
  员工的客户转发: 'Shares by Employees’ Customers',
  员工的客户点赞: 'Likes by Employees’ Customers',
  客户点赞累计: 'Total Likes by Customers',
  员工明细数据: 'Employee Data',
  查看所有员工明细数据: 'View All Employee Data',
  员工数据累计排行榜Top10: 'Top 10 Employees by Collective Data',
  '员工明细数据,单位：次数': 'Employee Detail Data, Unit: Times',
  截至: 'Until',
  客户的设备终端来源: 'Customer’s Device',
  员工已联系客户: 'Contacted Customers',
  客户查看排行榜Top10: 'Top 10 Customers by Views',
  客户转发排行榜Top10: 'Top 10 Customers by Shares',
  员工营销数据排行榜Top10: 'Top 10 Employees by Shares',
  客户点赞排行榜Top10: 'Top 10 Customers by Likes',
  客户主动查看列表: 'List of Customers Who Viewed Your Company Page',
  客户主动分享列表: 'List of Customers Who Shared Your Company Page',
  客户主动点赞列表: 'List of Customers Who Liked Your Company Page',
  '主动员工（或管理者）分享列表': 'List of Employees/Administrator Who Shared the Company Page',
  '员工（或管理者）': 'Employee (Or Administrator)',
  '所属员工（主账号/子账号）': 'Contact Person (Company Account/Employee Account)',
  '指的是企业的员工主动转发分享企业云展系统相关联内容的次数。':
    'It means the number of times employees who shared the company page.',
  '指的是企业云展系统相关联内容被非本企业的员工转发分享出去的次数。':
    'Total Shares by Customers refers to the number of times users other than your employees share contents from your company page.',
  '指的是企业云展系统相关联内容被非本企业的员工查看的次数。':
    'Total Views by Customers refers to the number of times contents from your company page are viewed by users other than your employees.',
  '指的是企业云展系统相关联内容被非本企业的员工点赞的次数。':
    'Total Likes by Customers refers to the number of times contents from your company page are liked by users other than your employees.',
  '搜索 员工用户名/子账号': 'Search Employ User Name/Employee Account',
  '搜索 客户用户名': 'Search Customer User Name',
  查看详情: 'Details of Views',
  转发详情: 'Details of Shares',
  点赞详情: 'Details of Likes',
  个人名片: 'Business Card',
  Ta的个人名片: 'His/Her Business Card',
  注意: 'note',

  招聘地区: 'Job Location',
  工作经验: 'Work Experience ',
  学历: 'Educational Background',
  云招聘: 'Online Recruitment',
  企业数据统计: 'Company Data Analysis',
  客户数据统计: 'Customer Data Analysis',
  潜在客户数据统计: 'Data Analysis of Potential Customers TOP 10',
  '企业云展系统完善度越高,曝光率权重越高,赶紧去完善吧！':
    'The more complete your company page is, the more exposure you get! ',
  分享来源: 'Shared on',
  分享次数: 'Total Shares',
  分享时间: 'Date',
  搜索客户名: 'Search Customer’s Name',
  Ta的企业云展系统: 'His/Her Company Page',
  查看记录: 'Details of His/Her Views',
  点赞记录: 'Details of His/Her Likes',
  转发记录: 'Details of His/Her Shares',
  // 招聘
  '您可以设置招聘顺序,数字越大越靠前,在您的企业云展系统则优先排序数字越大的招聘':
    'You can set the order of positions, the system will arrange the position in descending order from largest to smallest',
  发布招聘: 'Post a Position',
  职位名称: 'Position Name',
  职位ID: 'Position ID',
  已应聘人数: 'Number of Applicants',
  自动生成: 'Generate Automatically',
  默认: 'Default',
  一键复制: 'One-Click Copy',
  申请记录: 'Application Record',
  立刻使用: 'Use It Now',
  请填写真实姓名: 'Please fill in your real name',
  请填写职位名称: 'Please fill in the position name',
  添加照片: 'Add Photos',
  公司名: 'Company Name',
  企业简称不能为空: 'Company Name cannot be empty',
  投资比例不能为空: 'Investment Ratio cannot be empty',
  认缴金额不能为空: 'Subscribed Amount cannot be empty',
  企业简称: 'Company Name',
  请输入企业简称: 'Please enter the company name',
  企业英文简称: 'Company Name (English)',
  请输入企业英文简称: 'Please enter the company name (English)',
  是否对外显示: 'Whether to display outside',
  不显示: 'Not Display',
  添加投资机构: 'Add Investment Institution',
  添加手机号邮箱: 'Add Phone Number/Email',
  '手机号&邮箱': 'Phone Number/Email',
  企业二维码: 'Company QR Code',
  同事通过扫二维码可以加入企业: 'Your colleague can join your company by scanning the QR code',
  复制图片: 'Copy Image',
  企业链接: 'Company Link',
  添加企业员工: 'Add Employee',
  暂时不用: 'Temporarily Not Needed',
  马上升级: 'Upgrade Now',
  '套餐子账号已达上限,请升级套餐！':
    'The number of sub-accounts has reached the upper limit, please upgrade the package!',
  '子账号指的是你在企业的同事,你作为企业的管理者,有权向你企业的同事发出邀请其加入你的企业,共同为企业贡献更多力量':
    'Sub-accounts are your colleagues in your company. You are the company manager, you have the right to send invitations to your colleagues to join your company, and together contribute more power to your company',

  离职交接: 'Leaving Handover',
  交接人手机号: 'Handover Phone Number',
  请输入未注册手机号: 'Please enter an unregistered phone number',
  离职交接提示: 'Tip: After saving, the data of the account will be inherited to the new account',

  标签列表: 'tag list',

  '3步带你快速获客': '3 Steps to Get Guests',
  创建我的名片: 'Create personal cloud exhibition system',
  '一键发送,人脉裂变': 'to click, to get',
  创建企业云展系统: 'Create enterprise cloud exhibition system',
  '打造元宇宙企业,引爆百万客流': 'build a meta enterprise, ignite passengers',
  更多进阶操作: 'More actions',
  快速了解平台功能: 'Quick Learn',
  待企业认证: 'To be certified',
  '完成企业认证，享受更优服务，去认证 >': 'Go to certification and enjoy better service >',
  立即认证: 'Immediate authentication',
}
